module.exports = __webpack_public_path__ + "img/logo.87c4e2d.svg";